export default "__VITE_ASSET__9aec6a22__"